"use client";

import { createContext } from "react";

export const SpacedRepetitionConfigContext = createContext<{
  closestExamDate: DateString | null;
  lastSelectedDate?: DateString | null;
  days: ExamLearningPlanDayVM[] | null;
  sessions: Record<string, number>;
  specializations: Record<string, number>;
}>({
  closestExamDate: null,
  lastSelectedDate: null,
  days: null,
  sessions: {},
  specializations: {},
});
